export default __webpack_public_path__ + "static/sixth-5799c473c108f0f483987894c679c21a.jpg";